import React, { useEffect } from 'react';

import { calculateWalletDiscountPercentage } from '#/api/apiUtils';
import { useWalletWithPositionsQuery } from '#/api/queries/walletPositionsQueries';
import { formatNumber2 } from '#/lib/display/formatting';
import { setReferralCodeApplied } from '#/reduxState/currentUserData/userReferral';
import { staticDispatch, useSelector } from '#/reduxState/store';

import Banner from './Banner';

export default function BannerNoticeReferred() {
  const { data: walletWithPositionsData, refetch: refetchWalletWithPositions } =
    useWalletWithPositionsQuery(true, false /* slow refresh*/);
  const defaultTakerFeeRate = useSelector(
    state => state.exchange.info.defaultTakerFeeRate
  );
  const defaultMakerFeeRate = useSelector(
    state => state.exchange.info.defaultMakerFeeRate
  );

  useEffect(() => {
    // Get fresh wallet data
    refetchWalletWithPositions();
  }, [refetchWalletWithPositions]);

  const discountPercentage = calculateWalletDiscountPercentage(
    walletWithPositionsData,
    defaultMakerFeeRate,
    defaultTakerFeeRate
  );

  if (!discountPercentage) {
    return null;
  }

  const discountPercent = formatNumber2(discountPercentage, 2, 0);

  return (
    <Banner
      notice={{
        type: 'success',
        message: `Referral code successfully applied. All trades receive a ${discountPercent}% discount on fees`,

        // Previously: Referral code successfully applied. Trade on ${KATANA_PERPS} and receive ${discountPercent}% off your trade fees!

        isDismissable: true,
      }}
      onClose={() => {
        staticDispatch(setReferralCodeApplied(false));
      }}
    />
  );
}
